<template>
  <div class="repay-result">
    <!-- 只是为了兼容在APP内的情况 -->
    <navigation adaption/>
        
    <pulldown-page class="pull-down" :refresh="pulldown" background="white" color="#333333">
      <div class="call" @click="openCallDialog" v-if="platform.showTitle">
        <img src="../../assets/images/call.png"/>
        <span class="contact">联系客服</span>
      </div>
            
      <!-- 线上还款 -->
      <div class='repay-status'>
        <div class="animation-wapper" v-if="showGif">
          <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
        </div>
        <p class="status-title">{{ platform.name }}</p>
        <div class="status-description">
          <p v-for="(des, index) in platform.des" :key="index">{{ des }}</p>
        </div>
                
        <!-- <div class="bill-info" v-if="repayStatus === 'SUCCESS'">
          <div class="item">
            <p class="title">还款金额</p>
            <p class="content number">￥{{ repayResult.realTotalAmt | currency }}</p>
          </div>
          <div class="item">
            <p class="title">还款日期</p>
            <p class="content number">{{ repayResult.realRepayTime | date}}</p>
          </div>
          <div class="item">
            <p  class="title">还款平台</p>
            <p  class="content">天美贷</p>
          </div >
        </div>
        <div class="bill-info" v-else-if="repayStatus === 'PART'">
          <div class="item">
            <p class="title">已还款金额</p>
            <p class="content number">￥{{ repayResult.realTotalAmt | currency }}</p>
          </div>
          <div class="item">
            <p class="title">待还款金额</p>
            <p class="content number">￥{{ repayResult.crRepayTotalAmt | currency }}</p>
          </div>
          <div class="item">
            <p class="title">还款日期</p>
            <p class="content number">{{ repayResult.realRepayTime | date}}</p>
          </div>
          <div class="item">
            <p  class="title">还款平台</p>
            <p  class="content">天美贷</p>
          </div >
        </div> -->
        <div :class="repayResult.repayStatus==='IN_PROGRESS'?'mt300':'mt139'">
          <div v-if="repayResult.repayStatus==='IN_PROGRESS'">
            <div class="benner" v-if="bannerData.desc" @click="goSvip(10408)" >{{bannerData.desc}} ></div>
            <nd-button v-show="bannerData.buttonText" :class="['btn small line',{'width690 red':repayResult.repayStatus==='IN_PROGRESS'}]" @click="goSvip(10409)" >{{ bannerData.buttonText }}</nd-button>
          </div>
          <nd-button v-show="platform.showButton" :class="['btn small line',{'width320':repayResult.repayStatus==='IN_PROGRESS'}]" @click="backHome">{{ platform.buttonTitle }}</nd-button>
        
        </div>
      </div>

      <!-- 线下还款 -->
      <!-- <div class='repay-status' v-else>
        <div class="animation-wapper" v-if="showGif">
          <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
        </div>
        <p class="status-title" @click="play">{{ platform.name }}</p>

        <div class="status-description">
          <p v-for="(des, index) in platform.des" :key="index">{{ des }}</p>
        </div>
                
        <div class="bill-info" v-if="repayStatus === 'SUCCESS'">
          <div class="item">
            <p class="title">还款金额</p>
            <p class="content number">￥{{ repayResult.realTotalAmt | currency}}</p>
          </div>
          <div class="item">
            <p class="title">还款日期</p>
            <p class="content number">{{ repayResult.realRepayTime | date}}</p>
          </div>
          <div class="item">
            <p class="title">还款平台</p>
            <p class="content">天美贷</p>
          </div>
        </div>
        <div class="bill-info" v-else-if="repayStatus === 'PART'">
          <div class="item">
            <p class="title">已还款金额</p>
            <p class="content number">￥{{ repayResult.realTotalAmt | currency}}</p>
          </div>
          <div class="item">
            <p class="title">待还款金额</p>
            <p class="content number">￥{{ repayResult.crRepayTotalAmt | currency}}</p>
          </div>
          <div class="item">
            <p class="title">还款日期</p>
            <p class="content number">{{ repayResult.realRepayTime | date}}</p>
          </div>
          <div class="item">
            <p class="title">还款平台</p>
            <p class="content">天美贷</p>
          </div>
        </div>
        <div :class="repayResult.repayStatus==='IN_PROGRESS'?'mt300':'mt139'">
          <div v-if="repayResult.repayStatus==='IN_PROGRESS'">
            <div class="benner" v-if="bannerData.desc" @click="goSvip(10408)" >{{bannerData.desc}} ></div>
            <nd-button v-show="bannerData.buttonText" :class="['btn small line',{'width690 red':repayResult.repayStatus==='IN_PROGRESS'}]" @click="goSvip(10409)" >{{ bannerData.buttonText }}</nd-button>
          </div>
          <nd-button v-show="platform.showButton" :class="['btn small line',{'width690':repayResult.repayStatus==='IN_PROGRESS'}]" @click="goHomePage">{{ platform.buttonTitle }}</nd-button>
          
        </div>
                
      </div> -->
    </pulldown-page>
      

    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService" @close="closeDialog">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：4000100008</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { fail, wait, success } from '@/assets/json/index'
import { mapActions } from 'vuex'
import { mockHrefJump, judgeClientSystem, getKey } from '../../assets/utils'
import Lottie from 'vue-lottie'
export default {
  name: 'repayment-result',
  customReadyNotify: true,
  components: {
    'lottie': Lottie
  },

  data () {
    return {
      showGif: null,
      serviceVisible: false,
      repayResult: {},
      loanPlatform: this.$route.query.loanPlatform || 'YZD',
      termList: this.$storage.get('selectedTerms'),
      repayOrderNo: this.$route.query.repayOrderNo,
      type: this.$route.query.type,
      orderId: this.$route.query.orderId || '', 
      fundCode: this.$route.query.fundCode || '',
      animationSpeed: 1,
      bannerData: {} // 会员banner
    }
  },

  async created () {
    try {
      await this.getRepayResult()
      // this.point()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },
  mounted () {
    this.play()
  },

  methods: {
    ...mapActions('repay', ['consumptionRepayQueryX', 'getBusAccX', 'repayResultBanner']),
    ...mapActions('vip', [
      'memberInfo'
    ]), 
    handleAnimation (anim) {
      console.log('handleAnimation')
      this.anim = anim
    },
    // 埋点
    async  point () {
      const { repayStatus } = this.repayResult || {}
      let data = ''
      if (repayStatus === 'FAIL') {
        data = 'fail'
      } else if (repayStatus === 'IN_PROGRESS') {
        data = 'loading'
      } else {
        data = 'success'
      }
      const res = await this.memberInfo()
      let { meetSVIP } = res.data || {}
      if (this.type === 'online') {
        this.$report({ 
          id: 10002,
          args: {
            screen: 'page_repayment_result',
            status: meetSVIP ? 1 : 0,
            step: data
          }
        })
      } else {
        this.$report({ 
          id: 10002,
          args: {
            screen: 'page_reconciliations',
            status: meetSVIP ? 1 : 0,
            step: data
          }
        })
      }
    },
    goSvip (id) {
      this.$report({
        id
      })
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let data = `gid=${gid}&token=${token}&position=1`
      const channel = getKey('channel') || ''
      window.location.replace(`${process.env.VUE_APP_PAYURL}/vip/ssvip?${data}&channel=${channel}&refurl=${window.location.origin}`)
    },
    goWithDraw () {
      if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    stop () {
      console.log('stop')
      this.anim.stop()
    },

    play () {
      console.log('play')
    },

    pause () {
      console.log('pause')
      this.anim.pause()
    },

    onSpeedChange () {
      this.anim.setSpeed(this.animationSpeed)
    },

    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    openCallDialog () {
      this.$report({
        id: 10059, 
        args: {
          position: this.repayStatus
        }
      })
      this.serviceVisible = true
    },

    async refresh () {
      await this.getRepayResult()
      return true
    },
    // 是否展示banner
    async bannerResult () {
      let res = await this.repayResultBanner()
      if (res.success) {
        this.bannerData = res.data || {}
      }
    },
    async getRepayResult () {
      const params = {
        repayOrderNo: this.repayOrderNo
      }
      const response = await this.consumptionRepayQueryX(params)
      if (response.success) {
        this.repayResult = response.data
        // this.bannerResult()
        this.changeGif(this.repayResult.repayStatus || 'IN_PROGRESS')
      }
    },
    // 改变图片
    changeGif (value) {
      let title = {}
      if (this.type === 'offline') {
        if (['SUCCESS', 'PART'].includes(value)) {
          title = { animationData: success, loop: false }
        } else if (value === 'FAIL') {
          title = { animationData: fail, loop: false }
        } else if (value === 'IN_PROGRESS') {
          title = { animationData: wait }
        }
      } else {
        if (['SUCCESS', 'PART'].includes(value)) {
          title = { animationData: success, loop: false }
        } else if (value === 'FAIL') {
          title = { animationData: fail, loop: false }
        } else if (value === 'IN_PROGRESS') {
          title = { animationData: wait }
        }
      }
      this.$nextTick(() => {
        this.showGif = title
      })
    },
    closeDialog () {
      this.$report({
        id: 10062, 
        args: {
          postion: 'page_repayment_result'
        }
      })
    },

    callService () {
      // 点击客服弹框确定按钮
      this.$report({
        id: 10061, 
        args: {
          position: 'page_repayment_result',
          status: this.repayStatus, 
          target: this.repayResult.tel
        }
      })
      mockHrefJump(`tel:4000100008`)
    }
  }, 
  computed: {  
    repayStatus () {
      return this.repayResult.repayStatus || 'IN_PROGRESS'
    },
    platform () {
      if (this.type === 'offline') {
        if (['PART'].includes(this.repayStatus)) {
          return {
            name: '部分还款成功',
            des: [
              '您可通过银行流水查看还款明细,',
              '也可联系客服查询实际还款信息'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false 
          }
        } else if (['SUCCESS'].includes(this.repayStatus)) {
          return {
            name: '本次对账成功',
            des: [
              '您可通过银行流水查看还款明细,',
              '也可联系客服查询实际还款信息'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false 
          }
        } else if (this.repayStatus === 'FAIL') {
          return {
            name: '本次对账失败',
            des: [
              '您可联系客服，咨询详情'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: true 
          }
        } else if (this.repayStatus === 'IN_PROGRESS') {
          return {
            name: '对账处理中',
            des: [
              '您的对账申请已提交，请耐心等待… '
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false 
          }
        }
      } else {
        if (['PART'].includes(this.repayStatus)) {
          return {
            name: '部分还款成功',
            des: ['恭喜还款成功，订单状态稍后更新，请留意查看' 
            ],
            showButton: true,
            buttonTitle: '返回首页', 
            showTitle: false 
          }
        } else if (['SUCCESS'].includes(this.repayStatus)) {
          return {
            name: '支付成功',
            des: ['恭喜支付成功，订单状态稍后更新，请留意查看' 
            ],
            showButton: true,
            buttonTitle: '返回首页', 
            showTitle: false 
          }
        } else if (this.repayStatus === 'FAIL') {
          return {
            name: '支付失败',
            des: [
              '抱歉，本次支付失败，请您稍后重新发起支付；',
              '如有疑问，联系客服。'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: true 
          }
        } else if (this.repayStatus === 'IN_PROGRESS') {
          return {
            name: '支付中',
            des: [
              '您的支付申请已提交，请耐心等待支付结果',
              ''
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false 
          }
        }
      }
    }
  }
}
</script>

<style lang='less'>
@import "../../assets/less/mixin.less";

    .repay-result {
      .contact {
        font-size: 24px;
      }
        height: 100%;
        .mt139{
            margin-top: 139px;
        }
        .mt300{
            margin-top: 340px;
        }
        .benner{
            width: 690px;
            margin:auto;
            display:flex;
            align-items:center;
            justify-content:center;
            height: 100px;
            background: #FFF2F1;
            border-radius: 14px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF4633;
        }
        .page {
            overflow: auto;
        }
        .call {
            position: absolute;
            display: flex;
            justify-content:space-between;
            align-items: center;
            bottom: 92px;
            left:275px;
            width: 200px;
            height: 60px;
            background: #FAFAFA;
            border-radius: 40px;
            border: 1px solid #EEEEEE;
            padding:0 23px 0 28px;
            img{
            width: 29px;
            height:29px;
            span{
                width: 104px;
                height: 37px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 37px;
            }
            }
        }
        .repay-status {
            position: relative;
            text-align: center;
            top: 219px;
            .animation-wapper {
                height: 210px;
                width: 210px;
                margin: 0 auto;
            }

            .image {
                width: 190px;
                height: 190px;
            }
            .status-title {
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                line-height: 59px;
                font-size: 42px;
                margin-top: 51px;
                color: @fc1;
            }
            .status-description {
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:500;
                line-height: 37px;
                font-size: 26px;
                margin-top: 15px;
                color: @fc2;
            }

            .bill-info {
                padding: 0 30px;
                margin-top: 42px;
                padding-top: 42px;
                margin-left: 42px;
                margin-right: 42px;
                padding-bottom: 20px;
                font-size: 28px;
                text-align: left;
                background-color: #fafafa;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                border-radius: 20px;
                line-height: 50px;
                
                .item {
                    display:  flex;
                    flex-direction: row;
                    .title {
                        color: @fc2;
                        flex-shrink: 0;
                    }
                    .content {
                        color: @fc1;
                        margin-left: 42px;
                    }
                    .number {
                        font-family: DIN-Medium,DIN;
                        word-break: break-all;
                    }
                }
            }
            .btn {
                margin: 0 auto;
                margin-top: 30px;
            }
            .red{
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                color: #FFFFFF !important;
            }
            .width690{
                width:690px !important; 
            }
            .width320{
                width:320px !important;
            }
        }

        .service-dialog {
            padding: 10px 48px 80px;
            font-family: PingFangSC-Regular,PingFang SC;

            .title {
                font-size: 42px;
                height: 72px;
                line-height: 72px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
            }

            .description {
                font-size: 30px;
                height: 32px;
                line-height: 32px;
                margin-top: 22px;
                font-weight: 400;
            }
            .description1{
                font-size: 30px;
                height: 32px;
                line-height: 32px;
                margin: 12px auto 12px;
                font-weight: 400;
            }
            .telphone {
                font-size: 24px;
                height: 40px;
                line-height: 40px;
                margin-top: 2px;
                font-weight: 400;
                color: @fc3;
            }
        }
    }
</style>